<template lang="pug">
  .arrow-blue
    svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 31")
      g(fill="none" fill-rule="evenodd")
        path(d="M-9-3h36v36H-9z")
        path.arrow(d="M1.1 3.11l13.32 11.97a1.04 1.04 0 010 1.55L1.1 28.6a1.3 1.3 0 101.74 1.93l13.32-11.97a3.64 3.64 0 000-5.42L2.84 1.17A1.3 1.3 0 101.1 3.11z" fill-rule="nonzero")
  
</template>
<script>
export default {
  name: 'ArrowBlue',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.arrow-blue
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  .arrow
    fill: $cl-blue
  svg
    width: auto
    height: 100%
</style>
